<div class="d-flex flex-column gap-2">
  <div class="review-entry-label" i18n>Social Insurance Number</div>
  <div class="d-flex gap-2 align-items-center">
    <div class="review-entry-value flex-grow-1">{{ formattedSin$ | async }}</div>
    <button class="no-style-button" type="button" [disabled]="disabled" (click)="toggleShowFullSin()">
      <img [src]="iconSrc$ | async" alt="" height="24" width="24" [style.height.rem]="1.5" [style.width.rem]="1.5" />
    </button>
  </div>
  <hr class="m-0" />
</div>
